<div class="approw" *ngIf="userDetails">
  <div id="nav-col" class="open-sidenav" [class.disableleftnav]="isNavDisabled"
    [hidden]="!hasAccess('57c368b9820fea2470d6b9d3')">
    <section id="col-left" class="col-left-nano">
      <div id="col-left-inner" class="col-left-nano-content">
        <div class="navbar-collapse navbar-ex1-collapse" id="sidebar-nav">
          <ul class="nav nav-pills nav-stacked">
            <li class="nav-header nav-header-first hidden-sm hidden-xs">
              Navigation</li>
            <li uiSrefActive="active" *ngIf="hasAccess('57c368b9820fea2470d6b9c5') && !isVendor()">
              <a *ngIf="userDetails.roleScreenRef.role.name != '4dot5SuperUser' || userDetails.company.companyType != 'Host'"
                uiSref="missioncontrol.dashboard" [uiOptions]="{reload: true}">
                <i class="fas fa-tachometer-alt" title="Dashboard"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.DASHBOARD}}</span>
              </a>
            </li>
            <li uiSrefActive="active" *ngIf="hasAccess('57c368b9820fea2470d6b9c9') && userDetails.company.companyType !== 'Host'">
              <a uiSref="missioncontrol.candidates" [uiOptions]="{reload: true}">
                <i class="fa fa-users" title="Candidates"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.CANDIDATESVIEW}}</span>
              </a>
            </li>
            <li uiSrefActive="active" *ngIf="hasAccess('57c368b9820fea2470d6b9c7') && userDetails.company.companyType !== 'Host'">
              <a uiSref="missioncontrol.requisitions" [uiOptions]="{reload: true}">
                <i class="fa fa-briefcase" title="Requisitions"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.REQUISITIONS}}</span>
              </a>
            </li>
            <li *ngIf="userDetails.company.companyType !== 'Host' && isSuperUserOrFourDotFiveAdmin">
              <a class="dropdown-toggle"> <i class="fas fa-chart-line" title="Reports"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.REPORTS}}</span>
                <i class="fa fa-angle-right drop-icon"></i>
              </a>
              <ul class="submenu">
                <li>
                  <a uiSref="missioncontrol.reports.reviewReports" [uiParams]="{reportType: 'teamMembers'}"
                    [uiOptions]="{reload: true}">Review Reports</a>
                </li>
              </ul>
            </li>
            <li id="adminmenu">
              <a class="dropdown-toggle"> <i class="fa fa-cogs" title="Admin"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.ADMIN}}</span>
                <i class="fa fa-angle-right drop-icon"></i>
              </a>
              <ul class="submenu" id="adminmenulist">
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9e2')">
                  <a uiSref="missioncontrol.companymanagement"
                    [uiParams]="{selectedCompanyId: companyService.selectedCompanyId, clientOrBuObject: null, vendorId: null, accessMode: 'view'}"
                    [uiOptions]="{reload: true}">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGECOMPANY}}</span>
                  </a>
                </li>
                <li *ngIf="hasAccess('58f09d3bad87e252ea1ebfbc') && isCorporateCompany()">
                  <a uiSref="missioncontrol.clientsOrBus" [uiParams]="{selectedCompanyId: companyService.selectedCompanyId}"
                    [uiOptions]="{reload: true}">
                    <span> {{MESSAGECONSTANTS.LEFTNAVICONS.MANAGEBU}} </span>
                  </a>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9e1') && isStaffingCompany() && !isVendor()">
                  <a uiSref="missioncontrol.clientsOrBus" [uiParams]="{selectedCompanyId: companyService.selectedCompanyId}"
                    [uiOptions]="{reload: true}">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGECLIENT}}</span>
                  </a>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9e0') && !isInHost">
                  <a uiSref="missioncontrol.roleentityscope" [uiOptions]="{reload: true}">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGEROLEENTITY}}</span>
                  </a>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9de')">
                  <a uiSref="missioncontrol.teamMembers" [uiParams]="{iconClicked: 'manageusers', managerObj: null}"
                    [uiOptions]="{reload: true}"> <span>
                    {{MESSAGECONSTANTS.LEFTNAVICONS.MANAGEUSER}} </span>
                  </a>
                </li>
                <li>
                  <a class="cursor-pointer" uiSref="missioncontrol.employees" [uiOptions]="{reload: true}">
                    Manage Employee
                  </a>
                </li>
                <li *ngIf="hasAccess('58f09d3bad87e252ea1ebfbc') && isCorporateCompany()">
                  <a uiSref="missioncontrol.vendors" [uiOptions]="{reload: true}">
                    <span> {{MESSAGECONSTANTS.LEFTNAVICONS.ASSOCIATEVENDOR}} </span>
                  </a>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9df')">
                  <a uiSref="missioncontrol.settings" [uiOptions]="{reload: true}">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGESETTINGS}} </span>
                  </a>
                </li>
                <li *ngIf="isSuperUserOrFourDotFiveAdmin">
                  <a class="dropdown-toggle">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGEMASTERLISTS}} </span>
                    <i class="fa fa-angle-right drop-icon"></i>
                  </a>
                  <ul class="submenu">
                    <li>
                      <a uiSref="missioncontrol.manageSkills" [uiOptions]="{reload: true}">
                        <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGESKILLS}}</span>
                      </a>
                    </li>
                    <li><a uiSref="missioncontrol.masterLists" [uiOptions]="{reload: true}">{{MESSAGECONSTANTS.LEFTNAVICONS.OTHERS}}</a>
                    </li>
                  </ul>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9df') && !isVendor() && isSuperUserOrFourDotFiveAdmin">
                  <a uiSref="missioncontrol.assessmentManagement" [uiOptions]="{reload: true}">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.MANAGEASSESSMENTS}} </span>
                  </a>
                </li>
                <li *ngIf="hasAccess('57c368b9820fea2470d6b9df') && !isVendor()">
                  <a class="dropdown-toggle">
                    <span>{{MESSAGECONSTANTS.LEFTNAVICONS.FEEDBACKFORMS}} </span>
                    <i class="fa fa-angle-right drop-icon"></i>
                  </a>
                  <ul class="submenu">
                    <li><a uiSref="missioncontrol.feedbackforms" [uiParams]="{feedbackType: 'O'}"
                        [uiOptions]="{reload: true}">{{MESSAGECONSTANTS.LEFTNAVICONS.OUTREACHFEEDBACK}}</a>
                    </li>
                    <li><a uiSref="missioncontrol.feedbackforms" [uiParams]="{feedbackType: 'R'}"
                        [uiOptions]="{reload: true}">{{MESSAGECONSTANTS.LEFTNAVICONS.RECRUITERFEEDBACK}}</a>
                    </li>
                    <li><a uiSref="missioncontrol.feedbackforms" [uiParams]="{feedbackType: 'P'}"
                        [uiOptions]="{reload: true}">{{MESSAGECONSTANTS.LEFTNAVICONS.PHONESCREENFEEDBACK}}
                    </a></li>
                    <li><a uiSref="missioncontrol.feedbackforms" [uiParams]="{feedbackType: 'I'}"
                        [uiOptions]="{reload: true}">{{MESSAGECONSTANTS.LEFTNAVICONS.INTERVIEWFEEDBACK}}
                    </a></li>
                  </ul>
                </li>
                <li *ngIf="isSuperUserOrFourDotFiveAdmin || isLoggedInUserCompanyAdmin()">
                  <a uiSref="missioncontrol.aiActivities" [uiOptions]="{reload: true}"><span>Formalized Text</span></a>
                </li>
              </ul>
            </li>
            <li uiSrefActive="active" *ngIf="hasAccess('57c368b9820fea2470d6b9d5')">
              <a uiSref="missioncontrol.notifications" [uiOptions]="{reload: true}"> <i class="fa fa-bell" title="Notifications"></i> <span>{{MESSAGECONSTANTS.LEFTNAVICONS.NOTIFICATIONS}}</span>
              </a>
            </li>
            <li uiSrefActive="active" *ngIf="hasAccess('58f09d6fad87e252ea1ebfbd') && !isRecruiterManager(userDetails.roleScreenRef.role)">
              <a uiSref="missioncontrol.settings" [uiParams]="{accessMode: 'viewOnly'}" [uiOptions]="{reload: true}">
                <i class="fa fa-wrench" title="Settings"></i> <span>Settings</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <div id="nav-col-submenu"></div>
  </div>
  <div id="user-content-wrapper" [class.heig]="!isWorkflowScreenActive()" [class.pb-0]="isWorkflowScreenActive()">
    <div class="row">
      <div class="col-lg-12">
        <div class="slide-main-container">
          <div ui-view [class.slide-main-animation]="!isUploadReqScreenActive()"></div>
        </div>
      </div>
    </div>
  </div>
  <app-bulk-upload-status></app-bulk-upload-status>
</div>
